<template>
  <div class="one_people">
    <uni-popup ref="prescriptionWithPeople" type="bottom">
      <uni-card title="用药信息" :is-full="true" :note="true">
        <div class="wolf">
          <div class="medicineText">
            <div class="medicineTextTop">
              {{ dogrobber.prescripTemplateNum }}
            </div>
            <div class="['mdrug','medicineTextBottom']">
              {{ dogrobber.prescripName }}
            </div>
          </div>
          <div class="rat border_bottom" @click="medicationTime">
            <div class="leftSide">用药时间：</div>
            <div class="rigthSide">
              <span class="mdrug">
                {{ getKeyValueText('drug_use_time', useDrugTime) || '请选择用药时间' }}
              </span>
              <!-- <img class="img" src="@funcPuzzle/mini_doctor/clickInto.png" /> -->
            </div>
          </div>
          <div class="rat">
            <div class="leftSide">用药天数：</div>
            <div class="rigthSide" style="padding-right: 0.085333rem">
              <span class="mdrug">{{ timeMachine + ' ' }}</span>
            </div>
          </div>
        </div>
        <template v-slot:footer>
          <div class="footer-box" @click="selectPrescrip">
            <span class="btn">确认</span>
          </div>
        </template>
        <template v-slot:close>
          <uni-icons type="closeempty" color="#666" @click="close" />
        </template>
      </uni-card>
    </uni-popup>
    <ms-select-dicValue
      ref="useDrugTimePopup"
      :code="'drug_use_time'"
      :value="useDrugTime"
      v-model:visible="showUseDrugTimePopup"
      @change="setUseDrugTime"
      @start="startUseDrugTime"
    ></ms-select-dicValue>
    <!-- <uni-popup ref="ernieSauce" type="bottom">
      <picker-view
        :value="field"
        class="picker-view"
        :indicator-style="indicatorStyle"
        @change="change"
      >
        <picker-view-column>
          <div
            v-for="(item, index) in timeBox"
            :key="index"
            class="['mdrug','itemBox']"
          >
            {{ item.value }}
          </div>
        </picker-view-column>
      </picker-view>
    </uni-popup> -->
  </div>
</template>

<script>
import { getKeyValueText, getKeyValue } from '@/views/funcPuzzle/utils/util.js'
import { mapState } from 'vuex'
import MsSelectDicValue from '@/views/funcPuzzle/components/ms-select-dicValue/ms-select-dicValue.vue'

export default {
  components: {
    'ms-select-dicValue': MsSelectDicValue
  },
  computed: {
    ...mapState(['doctor'])
  },
  props: {
    dogrobber: {
      type: [Object, String],
      default: ''
    },
    ifUpdate: {
      type: Boolean,
      default: false
    },
    drugList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.open()
      } else {
        this.close()
      }
    },
    dogrobber(val) {
      // 蒙药用药时间
      this.timeBox = this.getKeyValue('drug_use_time')
    },
    drugList: {
      handler(val) {
        this.currentDrugList = val
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      showUseDrugTimePopup: false,
      medicineList: [],
      checked: '',
      timeMachine: 7,
      useDrugTime: '',
      indicatorStyle: 'height: 1.066667rem;',
      timeBox: [],
      currentDrugList: [],
      curUseDrugTime: '',
      map: {},
      field: [0]
    }
  },
  methods: {
    getKeyValueText,
    getKeyValue,
    close() {
      if (!this.$refs.prescriptionWithPeople) {
        return false
      }
      this.$emit('update:visible', false)
      this.$refs.prescriptionWithPeople.close()
      this.$bus.emit('cancelAddDrug', true)
    },
    open() {
      this.$emit('update:visible', true)
      this.$refs.prescriptionWithPeople.open()
      this.$nextTick(_ => {
        if (this.ifUpdate) {
          this.useDrugTime = this.dogrobber.useDrugTime
          this.changeUseDrugTime()
        } else {
          this.useDrugTime = ''

          const item = {
            detail: {
              value: [0]
            }
          }
          this.change(item)
        }
      })
    },
    changeUseDrugTime() {
      const index = this.timeBox.findIndex(val => val.code === this.useDrugTime)
      const item = {
        detail: {
          value: [index === -1 ? 0 : index]
        }
      }
      this.change(item)
    },
    medicationTime() {
      this.changeUseDrugTime()

      // 用药时间展示列表
      this.$refs.useDrugTimePopup.open()
      this.showUseDrugTimePopup = true
    },
    setUseDrugTime(val) {
      this.useDrugTime = val
    },
    startUseDrugTime(val) {
      this.useDrugTime = val
    },
    change(item) {
      this.curUseDrugTime = this.timeBox[item.detail.value[0]].code
      this.field = [item.detail.value]
    },
    // confirmDesc() {
    //   this.useDrugTime = !this.curUseDrugTime
    //     ? this.timeBox[0].code
    //     : this.curUseDrugTime

    //   this.$refs.ernieSauce.close()
    // },
    selectPrescrip() {
      if (this.useDrugTime === '') {
        uni.showToast({
          title: '请选择用药时间',
          icon: 'none'
        })
        return false
      }
      const drugList = JSON.parse(this.dogrobber.drugs).map(item => {
        return {
          ...item,
          amount: +item.amount,
          hospitalID: this.doctor.hospitalID,
          useDrugTime: this.useDrugTime,
          templateType: this.dogrobber.templateType
        }
      })
      // 一人一方传递参数
      const controller = {
        exhibition: true,
        templateType: this.dogrobber.templateType,
        prescripTemplateNum: this.dogrobber.prescripTemplateNum,
        prescripName: this.dogrobber.prescripName,
        useDrugTime: this.useDrugTime,
        timeMachine: 7
      }
      this.$nextTick(_ => {
        // 已经提交了一人一方数据
        if (this.currentDrugList && this.currentDrugList.length) {
          const _this = this
          uni.showModal({
            title: '提示',
            content: '继续操作的话，您之前已编辑的内容将会被替换，您确定继续？',
            success: res => {
              if (res.confirm) {
                _this.$bus.emit('drugList', {
                  val: drugList,
                  val2: controller
                })
                this.close()
                // 调用父级的 gearThree
                _this.$parent.$parent.open()
              } else if (res.cancel) {
                return false
              }
            }
          })
          // 还没有一人一方数据
        } else {
          this.$bus.emit('drugList', {
            val: drugList,
            val2: controller
          })
          this.close()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.one_people {
  width: 16rem;

  .wolf {
    width: 14.634667rem;
    height: 18.346667rem;
    margin: 0 auto;

    .medicineText {
      font-size: 0.64rem;
      color: #222;
      border-bottom: 0.021333rem solid #ececec;

      .medicineTextTop {
        margin: 0.682667rem 0;
      }
      .medicineTextBottom {
        margin-bottom: 0.682667rem;
      }
    }

    .border_bottom {
      border-bottom: 0.021333rem solid #ececec;
    }

    .rat {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 0.64rem;
      padding: 0.682667rem 0;

      .leftSide {
        color: #888888;
      }

      .rigthSide {
        color: #222;

        .img {
          margin-left: 0.213333rem;
          width: 0.554667rem;
          height: 0.554667rem;
        }
      }
    }
  }

  .footer-box {
    text-align: center;
    width: 14.634667rem;
    height: 1.877333rem;
    background: #0089ff;
    border-radius: 0.938667rem;
    line-height: 1.877333rem;
    font-size: 0.682667rem;
    font-weight: 500;
    .btn {
      color: #fff;
    }
  }

  .btn_row {
    display: flex;
    width: 100%;
    background-color: #fff;
    justify-content: space-between;
    .confirm_btn {
      height: 1.706667rem;
      background-color: #fff;
      padding: 0 0.853333rem;
      line-height: 2.56rem;
      color: #2772ff;
    }
  }

  ::v-deep .picker-view {
    height: 10.666667rem;
    background: #fff;
    .itemBox {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      height: 1.066667rem;
    }
  }
}
</style>
